const experienceData = [
  {
    id: 1,
    date: "2022 — Present",
    position: "Merchandise Planning Analyst & Sales Manager",
    company: "Memoreez · Torrance, CA",
    description:
      "Own demand forecasting, inventory turnover, and margin across 500+ SKUs for a dual-channel retail and e-commerce business, while leading a sales team. Diagnosed a competitor pricing shift through root cause analysis, redirecting strategy to targeted price adjustments and protecting a five-figure revenue stream — contributing to 25%+ revenue growth (~$200K incremental annually). Built a weekly KPI dashboard tracking sales, margin, and inventory metrics from scratch, replacing ad hoc spreadsheets and becoming leadership's single source of truth across 150+ reporting cycles. Automated data pipelines in Power Query across POS, Google Analytics, and manual inputs, cutting report prep time 90% (4+ hours to under 30 minutes)."
  },
  {
    id: 2,
    date: "2021 — 2022",
    position: "Sales Associate",
    company: "Memoreez · Torrance, CA",
    description:
      "Managed day-to-day retail sales and built strong product knowledge across the full catalog. Promoted to Merchandise Planning Analyst & Sales Manager within one year based on performance and analytical initiative."
  },
  {
    id: 3,
    date: "2013 — 2019",
    position: "Mathematics Teacher",
    company: "MOPI · Rio de Janeiro, Brazil",
    description:
      "Taught mathematics at the middle and high school level for six years. Built Excel-based academic performance tracking models covering 200+ students, adopted department-wide within one semester. Developed the ability to translate complex findings for non-technical audiences — a skill directly applied to demand forecasting and pricing analysis today."
  },
  {
    id: 4,
    date: "2014 — 2019",
    position: "Private Tutor, Mathematics & Physics",
    company: "Self-Employed · Rio de Janeiro, Brazil",
    description:
      "Tutored students independently, from middle schoolers to college entrance exam candidates and adults, sourcing clients directly and through local agencies. Diagnosed each student's specific gap and adapted explanations accordingly — the same instinct now applied to translating data for stakeholders."
  }
];

export default experienceData;